import { ChangeEvent } from "react";
import { AxSearch } from "@dynata/axiom3";
import "./audiences-search.scss";

export interface IAudienceSearchProps {
  searchTerm: string;
  setSearchTerm: (value: string) => void;
}

export function AudienceSearch({
  searchTerm,
  setSearchTerm,
}: IAudienceSearchProps) {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  };

  return (
    <div className="audiences-search">
      <AxSearch
        placeholder="Search by Context ID"
        value={searchTerm}
        onChange={handleChange}
      />
    </div>
  );
}
